/**
 * Moduł obsługujący sekcję odpowiedzi na karcie produktu
 * ładowanie komentarzy, dodawanie, usuwanie oraz zdarzenia
 * pokaz/ukryj komentarze
 */

app.service('comment',function(modal, validate, login, loading, captchaService, localStorage, text) {

	function removeSuccess(token, answer, force, html){
		if(force){
			var response=$.trim(html);
			if(response.length>0){
				modal.alert(response);
			}
			localStorage.removeItem('qc' + answer);
			$('#success-comment-'+answer).remove();
		}else{
			modal.generate({
				header: 'Usuwanie komentarza',
				content: html,
				id:'remove-comment-modal',
				buttons : [
					{
						text:'Tak',
						click: function () {
							modal.close();
							remove(token, answer, true);
						},
						cssClass: 'btn-second button-yes',
					},
					{
						text:'Nie',
						click: function () {
							modal.close();
						},
						cssClass:'btn-second button-no',
					}
				]

			});
		}
	}

	function remove(token, answer, force){
		var action=(force)?'CONFIRM_DELETE':'DELETE';
		loading.start();
		$.ajax({
			url:'/product-comment-form.ltr',
			method:'POST',
			data:{
				'ACTION':action,
				'commentToken':token
			},
			success:function(html){
				removeSuccess(token, answer, force, html);
			},
			complete:function(){
				loading.stop();
			},
			error:function(){
				modal.alert('Wystąpił błąd. Prosimy spróbować później');
			}
		});
	}
	function addInfo(answer){
		var itemValue = localStorage.getItem('qc' + answer) || false;
		if(itemValue){
			var comment= itemValue.split('|')[0];
			var text= itemValue.split('|')[1];
			var box=$('#comment-form-box-'+answer);
			if(box.length){
				var div=box.find('.success-comment');
				if(!div.length){
					div=$('<div/>').addClass('success-box success-comment').attr('id','success-comment-'+answer).html(text).appendTo(box);
					show(answer);
				}
				$('.js-comment-delete', div).click(function(){
					remove(comment, answer, false);
				});
			}
		}
	}
	function hide(token){
		$('#answer-'+token).removeClass('show-comments');
	}
	function show(token){
		$('#answer-'+token).addClass('show-comments');
	}
	function load(ajaxData,option){
		if(!option){
			option={};
		}
		var data={
			answerToken:false,
			pageNr:1,
			singlePage:true
		};
		$.extend(true,data,ajaxData);
		show(data.answerToken);
		var div=$('#comment-list-'+data.answerToken);
		div.addClass('loading');
		$.ajax({
			url:'/front-product-comments.ltr',
			type:'GET',
			data:data,
			success:function(html){
				if(data.pageNr!=1 || !data.singlePage){
					div.find('.more-load-comments-box').remove();
					div.append(html);
				}else{
					div.html(html);
				}
				if(option.callback){
					option.callback();
				}
				$('#answer-'+data.answerToken).each(function(){
					addInfo($(this).attr('id').substr(7));
				});
			},
			complete:function(){
				div.removeClass('loading');
			},
			error:function(){
				modal.alert('Wystąpił błąd ładowania komentarzy. Prosimy spróbować później');
			}
		});
	}
	function sendSuccess(answer){
		var div=$('#comment-form-box-'+answer+' .success-comment');
		$('#comment-form-'+answer).addClass('show-buttons');

		$('#comment-content-'+answer).wysiwyg();
		loadFormSuccess(answer, false);

		if(div.length){
			var name='qc'+answer;
			var value=div.data('comment-token')+'|'+div.html();
			var expires=1/24/60*parseInt(div.data('time'));
			localStorage.setItem(name, value, expires);
			addInfo(answer);
		}
	}
	function send(form){
		loading.start();
		var answer=form.data('answer');
		login.checkUniqueNick(function(){
			loading.start();
			form.ajaxSubmit({
				url:'/product-comment-form.ltr',
				data:{
					ACTION:'SAVE',
					answerToken:answer
				},
				type:'POST',
				target:'#comment-form-box-'+answer,
				beforeSubmit: function (payload) {
					const content = payload.find(el => el.name == 'content');
					content.value = text.clean(content.value);
				},
				success:function(){
					sendSuccess(answer);
				},
				error:function(){
					modal.alert('Wystąpił błąd zapisu komentarza. Prosimy spróbować później');
				},
				complete:function(){
					loading.stop();
				}
			});
		}, 'komentarza');
	}
	function loadFormSuccess(answer,focus){
		var div=$('#comment-form-box-'+answer);
		var form=div.find('form');
		validate.task('comment', {
			form:form,
			success:function(){
				send(form);
			}
		});
		if(focus){
			form.find('textarea').focus().click();
		}
		addCommentCaptcha(form);
	}
	function addCommentCaptcha($form) {
		var $captcha = $form.find('[data-toggle="captcha"]');
		if ($captcha.length) {
			captchaService.load($captcha.attr('id'), $captcha.data('place'));
		}
	}
	function loadForm(answer,focus){
		var div=$('#comment-form-box-'+answer);
		if(div.length){
			div.addClass('loading');
			show(answer);
			$.ajax({
				url:'/product-comment-form.ltr',
				type:'GET',
				data:{
					answerToken:answer
				},
				success:function(html){
					div.html(html);
					loadFormSuccess(answer,focus);
				},
				complete:function(){
					div.removeClass('loading');
				},
				error:function(){
					modal.alert('Wystąpił błąd ładowania formularza komentarzy. Prosimy spróbować później');
				}
			});
		}
	}
	function showFormAction(form){
		form.addClass('show-buttons');
	}
	function hideFormAction(form){
		form.removeClass('show-buttons');
	}


	return {
		loadForm:loadForm,
		load:load,
		hide:hide,
		showFormAction:showFormAction,
		hideFormAction:hideFormAction,
		addInfo:addInfo
	};
});
